import React from "react";
import { Wrapper } from "./AddRole.styled";
import { Button, Row, Col, Form, Input } from "components/common";

const AddRole = ({
  addRole,
  setAddRole,
  onPostAddRoleApi,
  setConfirm,
  isLoading,
}) => {
  const [form] = Form.useForm();
  const onLevelFinish = (value) => {
    onPostAddRoleApi(addRole);
    form.resetFields();
    setConfirm(false);
  };

  return (
    <Wrapper>
      <Form form={form} name="basic" autoComplete="off" onFinish={onLevelFinish}>
        <Row>
          <Col>
            <label className="label-text">Add New Level</label>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="role"
              rules={[
                {
                  required: true,
                  message: "Please Enter Level!",
                },
              ]}
            >
              <Input
                value={addRole?.levelName}
                onChange={(e) => {
                  setAddRole({
                    ...addRole,
                    role: e.target.value,
                  });
                }}
                placeholder="Add Level"
                className="input-field"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="priority"
            >
              <Input
                type="number"
                value={addRole?.priority}
                onChange={(e) => {
                  setAddRole({
                    ...addRole,
                    priority: e.target.value,
                  });
                }}
                placeholder="Add Priority"
                className="input-field"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="custom-row">
          <Col span={6}>
            <Form.Item name="submit">
              <Button
                loading={isLoading}
                htmlType="submit"
                title="Add"
                className="add-button"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Wrapper>
  );
};

export default AddRole;
